export default __webpack_public_path__ + "static/media/soul-red-right.67008137.png";